// extracted by mini-css-extract-plugin
module.exports = {"modal":"SearchWidget_modal__XpT4M","wrapper":"SearchWidget_wrapper__1cQRB"};